export interface Listener<T> {
    (event: T): any;
}

export interface Disposable {
    dispose(): void;
}

/** passes through events as they happen. You will not get events from before you start listening */
export class TypedEventEmitter<T> {
    private listeners: Record<string, Listener<T>[]> = {};

    on<T>(eventName: string, listener: Listener<T>): Disposable | null {

        let list: any[] = this.listeners[eventName];
        if (!list) {
            list = [];
            this.listeners[eventName] = list;
        }

        /* prevent duplicate listeners */
        for(const l of list){
            if( l === listener ) return null;
        }

        list.push(listener);
        return {
            dispose: () => this.off(eventName, listener)
        };
    }

    off<T>(eventName: string, listener: Listener<T>) {
        const list = this.listeners[eventName] ;
        if (list) {
            var callbackIndex = list.indexOf(listener as any);
            if (callbackIndex > -1) list.splice(callbackIndex, 1);
        }
    }

    emit = (eventName: string,event: T) => {
        const list = this.listeners[eventName];
        if (list) {
            list.forEach((listener) => listener(event));
        }

    }

}